import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Admin from './Component/AdminPanel/Admin';
import AppCarousel from './Component/AdminPanel/Pages/AppCarousel';
import UserInfo from './Component/AdminPanel/Pages/UserInfo';
import AllCarouselImg from './Component/AdminPanel/Pages/AllCarouselImg';
import Home from './Component/Home';
import Login from './Component/AdminLogin/Login';
import PrivateOutlet from './Component/PrivateRoute/PrivateRoute';
import AuthProvider from './Context/AuthContext';
import TermCondition from './Component/TermCondition/TermCondition';
import PrivacyPolicy from './Component/PrivacyPolicy/PrivacyPolicy';
function App() {
  return (
    <>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path='/login' element={<Login />} />
            <Route path="/dashboard/*" element={<PrivateOutlet />}>
              <Route path="admin/*" element={<Admin />}>
                <Route path="carousel" element={<AppCarousel />} />
                <Route path="userInfo" element={<UserInfo />} />
                <Route path="allCarousel" element={<AllCarouselImg />} />
              </Route>
            </Route>
            <Route path='/terms-and-conditions' element={<TermCondition />} />
            <Route path='/privacypolicy' element={<PrivacyPolicy />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
